/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tag: NonNullable<unknown> }} Iconik_Metadata_Tag_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove {tag}" |
*
* @param {Iconik_Metadata_Tag_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_tag_remove = /** @type {((inputs: Iconik_Metadata_Tag_RemoveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Tag_RemoveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
});